import React from "react";

import { ReactComponent as GoogleLogo } from "~/legacy-assets/images/logos/google.svg";
import { ReactComponent as MicrosoftLogo } from "~/legacy-assets/images/logos/microsoft.svg";
import { dispatchAnalyticsTrack } from "~/lib/segment";
import { Button } from "~/ui";

import { publicRecapSignup as signup } from "../auth";
import type { PublicRecapSignupTrigger } from "../PublicRecapSignupModal";

import styles from "./AuthButtons.module.css";

type AuthButtonProps = {
	accessKey?: string;
	trigger?: PublicRecapSignupTrigger;
	contentId?: string;
	iconOnly?: boolean;
};

const dispatchAnalytics = (provider: string, trigger?: PublicRecapSignupTrigger, contentId?: string) => {
	/* eslint-disable camelcase */
	dispatchAnalyticsTrack("[Public Recap] Auth Provider Button Clicked", {
		provider,
		modal_id: contentId,
		trigger,
	});
	/* eslint-enable camelcase */
};

export function GoogleAuthButton({ accessKey, trigger, contentId, iconOnly = false }: AuthButtonProps) {
	const onGoogleSignupClick = React.useCallback(() => {
		signup("google", accessKey);
		dispatchAnalytics("google", trigger, contentId);
	}, [accessKey, trigger, contentId]);

	return (
		<Button onClick={onGoogleSignupClick} variant="outlined" className={styles.authButton}>
			<GoogleLogo className={styles.authLogo} />
			{!iconOnly && "Continue with Google"}
		</Button>
	);
}

export function OfficeAuthButton({ accessKey, trigger, contentId, iconOnly = false }: AuthButtonProps) {
	const onOffice365SignupClick = React.useCallback(() => {
		signup("office365", accessKey);
		dispatchAnalytics("office365", trigger, contentId);
	}, [accessKey, trigger, contentId]);

	return (
		<Button onClick={onOffice365SignupClick} variant="outlined" className={styles.authButton}>
			<MicrosoftLogo className={styles.authLogo} />
			{!iconOnly && "Continue with Microsoft"}
		</Button>
	);
}
